/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
export { ClipboardModule, ClipboardDirective, ClipboardService } from "./src/ngx-clipboard";
//# sourceMappingURL=ngx-clipboard.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ngx-clipboard/dist/ngx-clipboard.js
// module id = ./node_modules/ngx-clipboard/dist/ngx-clipboard.js
// module chunks = vendor